"use client";

/* ── Site plan sketch canvas — public API ─────────────────────────────────
   A capable SVG drawing surface for the spatial half of site documents:
   traffic routes, escape routes, exclusion zones, fire points, assembly
   points, crane radii, freehand markup, measurements and inserted images.
   HSE guidance expects these documents to carry a marked-up plan — no free
   tool offers one, so this is deliberately the most capable thing on the
   page while staying printable and offline.

   Implementation lives in ./siteplan — this barrel keeps the import path
   stable for the five host tools (site safety plan sketcher, fire plan,
   lift plan, CPP, traffic management plan). */

export {
  useSitePlan,
  useSitePlanBackground,
  metresPerUnit,
  findCalibration,
  ICON_META,
  ROUTE_STYLE,
  ZONE_STYLE,
  type PlanBackground,
  type PlanElement,
  type IconType,
  type RouteType,
  type ZoneType,
} from "@/components/tools/siteplan/model";
export { PlanLegend, SitePlanPrint } from "@/components/tools/siteplan/PlanSvg";
export { SitePlanEditor } from "@/components/tools/siteplan/Editor";
